import {
  fetchAllLandingPageConfig,
  fetchLandingPageConfigWithShortname,
  fetchLandingPageServices,
  findBySrvrtid,
} from 'api/merchant';
import { useEffect, useState } from 'react';
import { MerchantLandingPageWithLayout } from './merchant-landing';
import MerchantLandingLoadingStates from '@components/common/layout/merchant-landing-page/loading-states';

export async function getStaticPaths() {
  const output = await fetchAllLandingPageConfig();
  const outputValue = Array.isArray(output) ? output : [];
  const merchantConfigs = outputValue?.filter((item) => {
    if (item.shortname && item.ms) {
      return !item.base_path;
    }
  });
  const paths = merchantConfigs.map((item) => ({ params: { shortname: item.shortname } }));
  return {
    paths: paths,
    fallback: false,
  };
}

export async function getStaticProps(context) {
  const merchantConfig = await fetchLandingPageConfigWithShortname(context.params.shortname);
  console.log('merchantConfig', merchantConfig);

  return {
    props: { merchantConfig },
  };
}

function MerchantLanding({ merchantConfig, ...props }) {
  const [loading, setLoading] = useState(true);
  const [merchantData, setMerchantData] = useState({
    merchant: {},
    merchantServices: [],
    merchantLandingConfig: {},
    merchantSrvrtid: '',
  });

  useEffect(() => {
    if (!merchantConfig) return;
    const { ms } = merchantConfig;
    (async () => {
      const merchantServices = await fetchLandingPageServices(ms);
      const merchant = await findBySrvrtid(ms);
      setMerchantData({
        merchant,
        merchantServices,
        merchantSrvrtid: ms,
        merchantLandingConfig: merchantConfig,
      });

      setLoading(false);

      // setTimeout(()=>{
      //   setLoading(false)
      // }, 100)
    })();
  }, [merchantConfig]);

  return (
    <>{loading ? <MerchantLandingLoadingStates /> : <MerchantLandingPageWithLayout {...props} {...merchantData} />}</>
  );
}

export default MerchantLanding;
